export default __webpack_public_path__ + "static/media/Black_Horse.bbda937b.png";